import { render, staticRenderFns } from "./lazy-image.vue?vue&type=template&id=ddd2de7a&scoped=true&"
import script from "./lazy-image.vue?vue&type=script&lang=js&"
export * from "./lazy-image.vue?vue&type=script&lang=js&"
import style0 from "./lazy-image.vue?vue&type=style&index=0&id=ddd2de7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd2de7a",
  null
  
)

export default component.exports